import React from "react";

/**
 * Label/value pairs in a modal. Rows whose value is missing are dropped rather than rendered
 * blank, so an order with no mobile on file does not show an empty line.
 */
function MetaList({ rows }) {
  const shown = rows.filter((row) => row[1] !== undefined && row[1] !== null && row[1] !== "");
  if (shown.length === 0) return null;
  return (
    <dl className="hm-dl">
      {shown.map((row) => (
        <div key={row[0]}>
          <dt>{row[0]}</dt>
          <dd>{row[1]}</dd>
        </div>
      ))}
    </dl>
  );
}

export default MetaList;
